import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { InventoryCustomUOMEvent } from '@inventory/models/edit-inventory.model';
import { InventoryProductViewModel } from '@inventory/models/inventory-view.model';
import { PlatformEnum } from '@panamax/app-state';
import { FormControl, Validators } from '@angular/forms';
import { BASE_INVENTORY_UNITS } from '@usf/ngrx-inventory';

@Component({
  selector: 'app-inventory-custom-uom-modal',
  templateUrl: './inventory-custom-uom-modal.component.html',
  styleUrls: ['./inventory-custom-uom-modal.component.scss'],
})
export class InventoryCustomUomModalComponent implements OnInit {
  readonly platformEnum = PlatformEnum;

  @Input() inventoryItem: InventoryProductViewModel;
  @Input() platformType: PlatformEnum;
  @Output()
  dismissModalEmitter: EventEmitter<boolean> = new EventEmitter();
  @Output()
  submitModalEmitter: EventEmitter<InventoryCustomUOMEvent> = new EventEmitter();

  customUnitInput = new FormControl('', [
    Validators.pattern(new RegExp(/^([a-zA-Z0-9]+ ?)*$/)),
  ]);

  existingLabels = BASE_INVENTORY_UNITS.slice();
  constructor() {}
  ngOnInit(): void {
    this.customUnitInput.patchValue(
      this.inventoryItem
        ? this.inventoryItem.customUOM
          ? this.inventoryItem.customUOM
          : ''
        : '',
    );
  }

  dismissModal() {
    this.dismissModalEmitter.emit(true);
  }

  handleCancel() {
    this.dismissModal();
  }

  handleSubmit() {
    this.submitModalEmitter.emit({
      inventoryItemId: this.inventoryItem.productNumber,
      groupName: this.inventoryItem.groupName,
      customUOM: this.customUnitInput.value,
    } as InventoryCustomUOMEvent);
  }
}
